import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const FeedbackButtons = ({ 
  messageId, 
  childAge, 
  childId,
  conversationId,
  onFeedbackGiven, 
  disabled = false 
}) => {
  const [selectedFeedback, setSelectedFeedback] = useState(null);
  const [showGenialAnimation, setShowGenialAnimation] = useState(false);
  const navigate = useNavigate();

  const handleFeedback = (feedback) => {
    if (disabled || selectedFeedback) return;
    
    // Animation "Génial!" pour le feedback "compris"
    if (feedback === 'understood') {
      setShowGenialAnimation(true);
      setTimeout(() => setShowGenialAnimation(false), 2000);
    }
    
    setSelectedFeedback(feedback);
    onFeedbackGiven(feedback);
  };

  const handleLaunchQuiz = () => {
    if (conversationId && childId) {
      navigate(`/quiz?conversation=${conversationId}&child=${childId}`);
    }
  };

  // Si feedback déjà donné, ne rien afficher (le parent ChatPage gère l'affichage)
  if (selectedFeedback) {
    return null;
  }

  return (
    <div>
      {/* Hint texte */}
      <p className="text-xs text-[#999999] text-right mb-2 mt-1">
        Cette réponse t'a plu ?
      </p>
      
      <div className="flex justify-end gap-2">
        {/* Bouton "Je n'ai pas compris" - Jaune/Orange (style app mobile) */}
        <button
          onClick={() => handleFeedback('too_hard')}
          disabled={disabled}
          className={`
            px-3 py-2 rounded-full transition-all duration-200
            bg-[#FFF9E6] border border-[#F5D79E]
            hover:bg-[#FFF3D6] hover:border-[#E5C78E] hover:shadow-md
            text-[#E67E22] text-sm font-medium
            ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer active:scale-95'}
          `}
        >
          🤔 Pas compris
        </button>

        {/* Bouton "Compris" - Vert gradient (style app mobile) */}
        <button
          onClick={() => handleFeedback('understood')}
          disabled={disabled}
          className={`
            px-4 py-2 rounded-full transition-all duration-200
            text-white text-sm font-medium shadow-md
            hover:opacity-90 hover:shadow-lg
            ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer active:scale-95'}
          `}
          style={{ background: 'linear-gradient(135deg, #4CAF50 0%, #45B7AA 100%)' }}
        >
          👍 Compris !
        </button>

        {/* Bouton "En savoir plus" - Bleu clair (style app mobile) */}
        <button
          onClick={() => handleFeedback('more_info')}
          disabled={disabled}
          className={`
            px-3 py-2 rounded-full transition-all duration-200
            bg-[#F0F8FF] border border-[#87CEEB]
            hover:bg-[#E0F0FF] hover:border-[#77BEDB] hover:shadow-md
            text-[#4A90A4] text-sm font-medium
            ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer active:scale-95'}
          `}
        >
          🧐 En savoir +
        </button>
      </div>

      {/* Bouton Lancer le quiz - Style app mobile (violet) */}
      {conversationId && childId && (
        <div className="flex justify-end mt-3">
          <button
            onClick={handleLaunchQuiz}
            className="flex items-center gap-2 px-5 py-3 rounded-full
              text-white font-semibold shadow-md
              hover:opacity-90 transition-all duration-200 active:scale-95"
            style={{ background: 'linear-gradient(135deg, #9B59B6 0%, #8E44AD 100%)' }}
          >
            <span className="text-lg">❓</span>
            <span>Lancer le quiz</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default FeedbackButtons;
